/**
 * ============================================================================
 * APP COMPONENT - Main Application
 * ============================================================================
 */

import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuthContext } from './providers';
import { useAnalyticsContext } from './providers';
import { useUIStore } from './store';
import AppRoutes from './routes';

/**
 * App Component
 * @returns {JSX.Element}
 */
function App() {
  const location = useLocation();
  const { trackPageView } = useAnalyticsContext();
  const { globalLoading, loadingMessage } = useUIStore();

  // Track page views on route change
  useEffect(() => {
    trackPageView(location.pathname, document.title);
  }, [location.pathname, trackPageView]);

  return (
    <div className="wekatrust-app min-h-screen bg-transparent text-[var(--color-text-primary)]">
      {/* Global Loading Overlay - dark theme */}
      {globalLoading && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm">
          <div className="bg-[var(--color-surface-raised)] rounded-xl p-6 shadow-xl border border-[var(--color-border)]">
            <div className="flex items-center gap-4">
              <div className="animate-spin rounded-full h-8 w-8 border-2 border-[var(--color-border)] border-t-[#22c55e]"></div>
              <div>
                <p className="font-medium text-[var(--color-text-primary)]">
                  {loadingMessage || 'Loading...'}
                </p>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Main App Content - All routes defined in routes.jsx */}
      <AppRoutes />
    </div>
  );
}

export default App;
